import React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';
import { IBuyboxViewPropsExtended } from '../types';

export const BuyboxViewCartLink = (props: IBuyboxViewPropsExtended) => {
    return (
        <Node className='ms-buybox__view-cart'>
            <Node className='ms-buybox__view-cart__text'>
                <a href={props.viewCartLink} className='ms-buybox__view-cart__link'>
                    {props.resources.viewCartLinkText}
                </a>
            </Node>
        </Node>
    );
};